import React from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { OrderReportDetailsScreen } from './OrderReportDetailsScreen';

export const OrderDetailsScreen: React.FC = () => {
  const { storeId, orderId } = useParams<{ storeId: string; orderId: string }>();
  const navigate = useNavigate();

  // If storeId is not in URL, try to get it from orderId
  // This handles backward compatibility with old routes
  if (!storeId && orderId) {
    // For backward compatibility, we'll need to fetch the order to get storeId
    // But for now, let's require storeId in the URL
    return (
      <div style={{ padding: '20px', textAlign: 'center' }}>
        <p>Order not found. Please go back and try again.</p>
        <button onClick={() => navigate('/manager/orders')}>Back to Orders</button>
      </div>
    );
  }

  return <OrderReportDetailsScreen />;
};
